// This file is generated by a script. Do not edit this file directly.
import React from "react";
import { Avatar } from "../Avatar/Avatar";
import { Chip } from "../Chip/Chip";
export function SelectedValueChip(props) {
  var _option$avatarSrc, _option$avatarFallbac, _option$label, _option$companyAvatar, _option$companyAvatar2, _option$companyName$c, _option$companyName, _option$companyName2, _option$label2;
  var option = props.data,
    selectProps = props.selectProps;
  var onChange = selectProps.onChange,
    selectValue = selectProps.value;
  var handleRemove = function handleRemove() {
    if (Array.isArray(selectValue)) {
      var newSelectValue = selectValue ? selectValue.filter(function (_ref) {
        var value = _ref.value;
        return !(value === option.value);
      }) : [];
      onChange(newSelectValue, {
        action: 'remove-value',
        removedValue: option
      });
    }
  };
  return /*#__PURE__*/React.createElement(Chip, {
    className: "!cop-rounded cop-border cop-border-solid cop-px-2 cop-py-[5px]",
    variant: "outlined",
    onClose: handleRemove,
    prefixIcon: /*#__PURE__*/React.createElement("div", {
      className: "cop-relative cop-flex"
    }, /*#__PURE__*/React.createElement(Avatar, {
      src: (_option$avatarSrc = option.avatarSrc) !== null && _option$avatarSrc !== void 0 ? _option$avatarSrc : '',
      fallbackColor: (_option$avatarFallbac = option.avatarFallbackColor) !== null && _option$avatarFallbac !== void 0 ? _option$avatarFallbac : '',
      size: "sm",
      className: "cop-box-border cop-h-4 cop-w-4",
      alt: (_option$label = option.label) !== null && _option$label !== void 0 ? _option$label : '',
      variant: option.type === 'company' ? 'rounded' : 'circle',
      text: option.label.charAt(0).toLocaleUpperCase()
    }), option.type === 'client' && option.companyName && /*#__PURE__*/React.createElement(Avatar, {
      fallbackClassName: "!cop-text-[8px] !cop-leading-none",
      src: (_option$companyAvatar = option.companyAvatarSrc) !== null && _option$companyAvatar !== void 0 ? _option$companyAvatar : '',
      fallbackColor: (_option$companyAvatar2 = option.companyAvatarFallbackColor) !== null && _option$companyAvatar2 !== void 0 ? _option$companyAvatar2 : '',
      text: (_option$companyName$c = (_option$companyName = option.companyName) === null || _option$companyName === void 0 ? void 0 : _option$companyName.charAt(0).toLocaleUpperCase()) !== null && _option$companyName$c !== void 0 ? _option$companyName$c : '',
      size: "sm",
      className: "!cop-absolute cop-bottom-[-2px] cop-right-[-2px] cop-box-border cop-h-[10px] cop-w-[10px] cop-rounded-[2px]",
      alt: (_option$companyName2 = option.companyName) !== null && _option$companyName2 !== void 0 ? _option$companyName2 : '',
      variant: "rounded"
    })),
    label: (_option$label2 = option.label) !== null && _option$label2 !== void 0 ? _option$label2 : ''
  });
}
